<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromPermission" ref="fromPermission" class="demo-form-inline" :rules="rules">
                <el-row :gutter="20">
                    <td-permission :roles="roles" style="float:right;">
                        <div slot="havePermission">
                            <el-form-item :label="$t('common.CURSYS')">
                                <td-select
                                    v-model="sSysFlg"
                                    :placeholder="$t('common.PLEASE_SELECT')"
                                    @change="queryPageBySys()"
                                    :options="this.sysAndFlgList"
                                    keys="sSysFlg"
                                    text="sName"
                                    :clearable="false"
                                >
                                </td-select>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission" class="divClass">
                            <el-form-item :label="$t('common.RESTYPENAME')">
                                <td-input v-model="fromPermission.resName"></td-input>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item>
                        <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                        <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddPermission">{{ $t('common.ADD') }}</td-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="false"
                :hasLoading="loading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                rowKey="resId"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-PermissionInfo
                v-if="dialogPermissionVisible"
                :isAddData="isAddData"
                :dialogPermissionVisible="dialogPermissionVisible"
                :sSysFlg="sSysFlg"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @permissionDialogClose="permissionDialogClose"
                @submit="submit"
            ></dialog-PermissionInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogPermissionInfo from './components/dialogPermissionInfo.vue';
import resourceApi from './assets/api.js';
// import { debug } from 'util'
export default {
    // 初始化渲染
    components: {
        'dialog-PermissionInfo': dialogPermissionInfo
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.sSysFlg = this.$common.systemInfo.systemId;
        } else {
            this.sSysFlg = 'PG';
        }
        resourceApi.getSysList(JSON.stringify(''), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryPageList(); // 进行页面初始化数据的加载
    },
    beforeDestroy() {
        window.getCurrentMenu = null;
        // this.Sortable = null;
        // this.doLayout = null;
        // this.sort = null;
        // this.setSort = null;
        // this._initTableHeight = null;
        // this.dealPermissions = null;
    },
    // 定义数据
    data() {
        return {
            fromPermission: {
                resName: '',
                sIp: ''
            },
            editItem: '',
            permissionsAdd: ['res:add'],
            permissionsEdit: ['res:edit'],
            permissionsView: ['res:view'],
            permissionsDel: ['res:del'],
            roles: ['admin'],
            dialogPermissionVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            sSysFlg: '',
            sysList: [],
            sysAndFlgList: [],
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                resName: [
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_RES_CAPTION_ILLEGAL')
                    }
                ]
            },
            columns: [
                {
                    prop: 'resName',
                    label: this.$t('common.RESTYPENAME')
                },
                {
                    prop: 'sPermissionStr',
                    label: this.$t('common.AUTH_STR')
                },
                {
                    prop: 'authName',
                    label: this.$t('common.AUTHTYPES')
                },
                {
                    prop: 'description',
                    label: this.$t('common.DESCRIPTION')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.resId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 根据mq的id显示对应的类型名称
        formatterType(row) {
            switch (row.iType) {
                case 0:
                    return this.$t('common.RABBITMQ');
                default:
                    return this.$t('common.UNKNOW_TYPE');
            }
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        queryPageBySys() {
            this.currentPage = 1;
            if (this.sSysFlg !== 'nextPageValue' && this.sSysFlg !== 'lastPageValue') {
                this.btnQuery();
            }
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                // sname: this.fromPermission.sName,
                // sip: this.fromPermission.sIp,
                resName: this.fromPermission.resName,
                sSysFlg: this.sSysFlg,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.listPermissionInfos(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('res/getRoleResTypeList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddPermission() {
            this.title = this.$t('common.ADD_RES'); // 标题
            this.isAddData = true;
            this.dialogPermissionVisible = true;
        },
        // 添加
        btnRefresh() {
            this.title = this.$t('common.QUERY'); // 标题
            this.isAddData = true;
            this.dialogPermissionVisible = true;
        },
        // 编辑
        btnEdit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT_RES');
            this.isAddData = false;
            this.dialogPermissionVisible = true;
        },
        // 删除接口
        btnDelete(resId) {
            this.$confirm(this.$t('error.DELETE_AUTHSTR_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'error'
            })
                .then(() => {
                    let param = { resId: resId };
                    resourceApi.deleteResInfo(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('res/deleteResInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    this.$log.error('res/deleteResInfo---- Fail');
                });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        permissionDialogClose() {
            this.dialogPermissionVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.divClass {
    padding-left: 10px;
}
</style>
